import React from 'react';
import { FormControl } from 'components/form';
import BaseHint from 'components/hintTypes/BaseHint';
import { Intent } from 'constants/ui';
import { getExistingPartnerSinglePaymentMethodHintTitle } from '../helpers/text';
import {} from './ExistingPartnerSinglePaymentMethodHint.types';
const ExistingPartnerSinglePaymentMethodHint = ({ availablePaymentMethods, }) => (React.createElement(FormControl, null,
    React.createElement(BaseHint, { intent: Intent.INFO, title: getExistingPartnerSinglePaymentMethodHintTitle(availablePaymentMethods) })));
export default ExistingPartnerSinglePaymentMethodHint;
